export default __webpack_public_path__ + "static/media/login-bg.98bac3b2.png";